(() => {
  const animatedItems = document.querySelectorAll(
    '[data-eautre-reveal], [data-eautre-fade]'
  );

  if (!animatedItems.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.22,
    rootMargin: '0px 0px -8% 0px'
  });

  animatedItems.forEach((item) => observer.observe(item));
})();

(() => {
  const header = document.querySelector('.eautre-header');
  if (!header) return;

  const updateHeader = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  };

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
})();